/* eslint-disable @typescript-eslint/no-explicit-any */
import { Option } from "./index";

export const getAllLeafValues = (options: Option[]): any[] => {
  let leaves: any[] = [];
  options.forEach(option => {
    if (!option.children || option.children.length === 0) {
      leaves.push(option.value);
    } else {
      leaves = leaves.concat(getAllLeafValues(option.children));
    }
  });
  return leaves;
};

export const getDescendantLeafValues = (parent: Option): any[] => {
  if (!parent.children || parent.children.length === 0) {
    return [];
  }
  return getAllLeafValues(parent.children);
};

export const getAllLeafOptions = (options: Option[]): Option[] => {
  let leaves: Option[] = [];
  options.forEach(option => {
    if (!option.children || option.children.length === 0) {
      leaves.push(option);
    } else {
      leaves = leaves.concat(getAllLeafOptions(option.children));
    }
  });
  return leaves;
};

export const getDescendantLeafOptions = (parent: Option): Option[] => {
  if (!parent.children || parent.children.length === 0) {
    return [];
  }
  return getAllLeafOptions(parent.children);
};
